import React from "react";
import styled from "styled-components";
import { NetworkStatus } from "apollo-client";
import { borders, colors } from "@sonder/ui/source/styled/theme";
import { useStore as useAuthStore } from "auth/store";
import { ONE_MINUTE } from "core/constants";
import { usePageVisibilityPolling } from "core/hooks/usePageVisibilityPolling";
import { useRefetchableGetBuildingSupervisorsQuery } from "core/queries/GetBuildingSupervisors";
import {
  BuildingSupervisorsList,
  BuildingSupervisorsListOuterContainer,
} from "supervisors/components/BuildingSupervisorsList";
import { SupervisorsListLoader } from "supervisors/components/SupervisorsList.loader";
import { useStore as useTasksStore } from "tasks/store";

const SupervisorsListLoaderWrapper = styled.div`
  background: ${colors.white};
  border-left: 1px solid #e1e2e5;
  border-radius: 0.3rem;
  border: ${borders.standard};
  padding: 1.375rem 1rem 0.75rem;
`;

export const SupervisorsList = () => {
  const {
    state: { user },
  } = useAuthStore();
  const {
    state: {
      filters: { buildingIds },
    },
  } = useTasksStore();

  const variables = {
    filter: {
      activeOnly: true,
      city: user?.cityId,
      ids: buildingIds,
    },
  };

  const {
    loading,
    data,
    error,
    networkStatus,
    refetch,
    startPolling,
    stopPolling,
  } = useRefetchableGetBuildingSupervisorsQuery({
    pollInterval: ONE_MINUTE,
    skip: !user?.cityId,
    variables,
  });
  usePageVisibilityPolling({
    pollInterval: ONE_MINUTE,
    refetch,
    variables,
    startPolling,
    stopPolling,
  });
  const buildings = data?.buildingConnections.buildings || [];
  const isPolling = networkStatus === NetworkStatus.poll;
  const isRefetching = networkStatus === NetworkStatus.refetch;
  const isAcuallyLoading = loading && !isPolling && !isRefetching;

  if (isAcuallyLoading && !data) {
    return (
      <BuildingSupervisorsListOuterContainer>
        <SupervisorsListLoaderWrapper>
          <SupervisorsListLoader />
        </SupervisorsListLoaderWrapper>
      </BuildingSupervisorsListOuterContainer>
    );
  }

  if (error) {
    return (
      <BuildingSupervisorsListOuterContainer>
        {error.message}
      </BuildingSupervisorsListOuterContainer>
    );
  }

  return (
    <>
      {buildings.map(building => (
        <BuildingSupervisorsList
          building={building}
          key={building.id}
          loading={isAcuallyLoading}
        />
      ))}
    </>
  );
};
